import PriceTable from './Price.gql';

export default PriceTable;
